import(/* webpackMode: "eager" */ "/home/runner/work/terzotempo/terzotempo/components/common/WhatsappLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/terzotempo/terzotempo/components/home/FaqAccordion.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/terzotempo/terzotempo/components/home/ProssimaSerataSection.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/terzotempo/terzotempo/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/terzotempo/terzotempo/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/terzotempo/terzotempo/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
